<template>
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99805 8.00281C9.62695 7.16663 10 6.12683 10 5C10 2.23853 7.76123 0 5 0C2.23877 0 0 2.23853 0 5C0 7.76147 2.23877 10 5 10C6.12695 10 7.1665 9.62732 8.00244 8.99841C8.03857 9.07654 8.08887 9.14966 8.15332 9.21411L11.5928 12.6536C11.8857 12.9464 12.3604 12.9464 12.6533 12.6536C12.9463 12.3606 12.9463 11.8857 12.6533 11.5929L9.21387 8.15356C9.14941 8.08911 9.07617 8.03894 8.99805 8.00281ZM5 9C7.20898 9 9 7.20911 9 5C9 2.79089 7.20898 1 5 1C2.79102 1 1 2.79089 1 5C1 7.20911 2.79102 9 5 9Z" fill="#8C8C8C"/>
    </svg>
</template>

<script>
    export default {
        name: "Lens"
    }
</script>

<style scoped>

</style>